/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface SpecificiteCoursSearch
 */
export interface SpecificiteCoursSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof SpecificiteCoursSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof SpecificiteCoursSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof SpecificiteCoursSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof SpecificiteCoursSearch
     */
    isCompanySearch?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpecificiteCoursSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SpecificiteCoursSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SpecificiteCoursSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SpecificiteCoursSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SpecificiteCoursSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SpecificiteCoursSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SpecificiteCoursSearch interface.
 */
export function instanceOfSpecificiteCoursSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SpecificiteCoursSearchFromJSON(json: any): SpecificiteCoursSearch {
    return SpecificiteCoursSearchFromJSONTyped(json, false);
}

export function SpecificiteCoursSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecificiteCoursSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'isCompanySearch': !exists(json, 'isCompanySearch') ? undefined : BooleanSearchFromJSON(json['isCompanySearch']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SpecificiteCoursSearchToJSON(value?: SpecificiteCoursSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': TextSearchToJSON(value.code),
        'libelle': TextSearchToJSON(value.libelle),
        'actif': BooleanSearchToJSON(value.actif),
        'isCompanySearch': BooleanSearchToJSON(value.isCompanySearch),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

